import React from "react";
import "./Info.css";
const Info = () => {
  return (
    <div className="info">
      <div className="heading-container">
        <div className="heading-line"></div>
        <div className="heading"> Hamara IIIT Tiranga 15 August, 2023</div>
      </div>
      <div className="text1">
      The grand finale of our Independence Day celebrations will see our entire institution transformed into a beacon of patriotism and pride. Every corner of the campus will be adorned with lights, flags, and the vibrant tri-colors of the Tiranga. This visual spectacle will serve as a testament to our love for our country and our commitment to the values it represents.

In addition to the beautiful decorations, we will set up special selfie points, allowing everyone to capture this memorable day and share it with the world. These pictures will be featured on our institute's website, creating a lasting digital memory of our collective celebration.

The "Hamara IIT Tiranga" event isn't just about decorations and pictures; it's a reminder of the freedom we enjoy and the responsibility we bear to uphold and cherish it. It's a day to celebrate our institution's role in shaping future leaders and contributing to the progress of our nation. Together, let's make this Independence Day unforgettable and full of pride for our Tiranga, our India! <a href=" /login"> <b>Upload Photos</b></a>   
      </div>

      <div className="extra">
        <div className="date">
          <span style={{ fontWeight: "bold" }}>Date</span>: 15 August, 2023
        </div>
        {/* <div className="time">Time: 4:00 PM</div>
        <div className="location">Venue: Adminsitrative Building</div> */}
      </div>
    </div>
  );
};

export default Info;
